import React, { useState } from 'react';
import { X, ChevronLeft, ChevronRight, Download, ExternalLink, Calendar, MapPin } from 'lucide-react';

const Gallery = () => {
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState('All');

  const categories = ['All', '2025', '2024', '2023', '2022', '2021'];

  const events = [
    {
      id: 1,
      name: "INTERNATIONAL CONFERENCE ON RECENT INNOVATIONS IN MULTIDISCIPLINARY RESEARCH ICRIMR – 2025 & GOA EDUCATIONAL PEARL AWARDS 2025",
      date: "26th MAY 2025",
      venue: "GOA COLLEGE OF ENGINEERING, GOA",
      year: "2025",
      photoLinks: [
        "https://drive.google.com/file/d/1EslIyr10ARRWOv44uPkq5a7wkwptZslV/view?usp=sharing"
      ],
      thumbnail: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      id: 2,
      name: "INTERNATIONAL CONFERENCE ON MULTIDISCIPLINARY RESEARCH PERSPECTIVE ICMRP – 2025 & INNOVATIVE EDUCATION AWARD 2025",
      date: "14th to 16th MAY 2025",
      venue: "DWIJENDRA UNIVERSITY, BALI, INDONESIA",
      year: "2025",
      photoLinks: [
        "https://drive.google.com/drive/folders/13ezXWJ3LAkvFvHMfLHECqRpNdsfvzWxU?usp=drive_link",
        "https://drive.google.com/drive/folders/13KzmNp6btoVjefb4ok8zD1-ID1y7OvZS?usp=drive_link"
      ],
      thumbnail: "https://images.unsplash.com/photo-1591115765373-5207764f72e7?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      id: 3,
      name: "INTERNATIONAL CONFERENCE ON INNOVATIVE RESEARCH AND DEVELOPMENT ICIRD-2025 & INDO – THAI INTERNATIONAL EXCELLENCE AWARDS",
      date: "03rd to 05th MARCH 2025",
      venue: "SHINAWATRA UNIVERSITY, THAILAND",
      year: "2025",
      photoLinks: [
        "https://drive.google.com/drive/folders/12-D1uVNQ8Jl4HdOWfaziCjZpAB_uTBMe?usp=drive_link"
      ],
      thumbnail: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      id: 4,
      name: "INTERNATIONAL CONFERENCE ON INNOVATIVE RESEARCH AND DEVELOPMENT ICIRD-2025 & MALAYSIA ICONIC AWARDS 2025",
      date: "17th to 19th FEBRUARY 2025",
      venue: "INTI - INTERNATIONAL UNIVERSITY, MALAYSIA",
      year: "2025",
      photoLinks: [
        "https://drive.google.com/drive/folders/11RO36uMsG2v5uDHnfbdQz4M78KJ-tYX_?usp=sharing"
      ],
      thumbnail: "https://images.unsplash.com/photo-1523580494863-6f3031224c94?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      id: 5,
      name: "INTERNATIONAL CONFERENCE ON MULTIDISCIPLINARY RESEARCH (ICMR - 2024) & Multiple Awards",
      date: "15th DECEMBER 2024",
      venue: "IIT ALUMNI INDUSTRY INTERACTION CENTER, IIT MADRAS RESEARCH PARK, CHENNAI",
      year: "2024",
      photoLinks: [
        "https://drive.google.com/drive/folders/1VL_RvaCyi4uUf2niRZG0zEcerc3b1r-Z?usp=sharing",
        "https://drive.google.com/drive/folders/11aB1Uw-Hvmmu18w3ze4qsE2vbuT1-e-9?usp=sharing",
        "https://drive.google.com/drive/folders/1OGYxbuqyq0ldEY-i4Q3yagtHDp08uvYY?usp=sharing",
        "https://drive.google.com/drive/folders/14rhgYguqI3rmHKc4Ie7nyPDJNAjeW-YJ?usp=sharing",
        "https://drive.google.com/drive/folders/1wuFWRrROjdbrogRjhORvca1FEkEotBPm"
      ],
      thumbnail: "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      id: 6,
      name: "INTERNATIONAL CONFERENCE ON INNOVATIVE RESEARCH AND DEVELOPMENT ICIRD-2024",
      date: "08th to 11th NOVEMBER 2024",
      venue: "SHINAWATRA UNIVERSITY, THAILAND",
      year: "2024",
      photoLinks: [
        "https://drive.google.com/drive/folders/1KOXfqhJTtBgcjPvyWUwTsqtyIy6NGEJp?usp=sharing"
      ],
      thumbnail: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      id: 7,
      name: "INTERNATIONAL CONFERENCE ON EMERGING TRENDS AND INNOVATIONS ICETI-2024 & GLOBAL ICONIC AWARDS 2024",
      date: "21st to 23rd OCTOBER 2024",
      venue: "NATIONAL UNIVERSITY OF ARTS EDUCATION, VIETNAM",
      year: "2024",
      photoLinks: [
        "https://drive.google.com/drive/folders/13DU2fMp3otye8CfX-ZtVT3-SUfTiELqn?usp=drive_link"
      ],
      thumbnail: "https://images.unsplash.com/photo-1591115765373-5207764f72e7?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      id: 8,
      name: "UAE INTERNATIONAL CONFERENCE ON MULTIDISCIPLINARY RESEARCH AND INNOVATION (ICMRI – 2024) & DUBAI EDUCATION AWARD - 2024",
      date: "19th to 21st SEPTEMBER 2024",
      venue: "WESTFORD UNIVERSITY COLLEGE, DUBAI UAE",
      year: "2024",
      photoLinks: [
        "https://drive.google.com/drive/folders/1oIxPr3PAB9AnGXSInQGi4SNw1bvys--M?usp=sharing"
      ],
      thumbnail: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      id: 9,
      name: "INTERNATIONAL CONFERENCE ON MULTIDISCIPLINARY RESEARCH AND DEVELOPMENT (ICMRD - 2024) & INTERNATIONAL ICONIC AWARD – 2024",
      date: "AUGUST 25th, 2024",
      venue: "CORDELIA CRUISE",
      year: "2024",
      photoLinks: [
        "https://drive.google.com/drive/folders/14CVgQ-c8Cg6xuhhvtv47jvM60XJga8VR"
      ],
      thumbnail: "https://images.unsplash.com/photo-1523580494863-6f3031224c94?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      id: 10,
      name: "INTERNATIONAL CONFERENCE ON INNOVATIVE RESEARCH AND DEVELOPMENT (ICIRD - 2024) & INDO - THAI PRIDE OF EDUCATION AWARDS",
      date: "MAY 28th to 30th, 2024",
      venue: "SHINAWATRA UNIVERSITY, THAILAND",
      year: "2024",
      photoLinks: [
        "https://drive.google.com/drive/folders/1p1VssWceBPbNydtTfZuGfNhUOnQUqD0e"
      ],
      thumbnail: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      id: 11,
      name: "INTERNATIONAL CONFERENCE ON LATEST TRENDS IN INNOVATION ICLTI-2024 & Multiple Awards",
      date: "28th April 2024",
      venue: "IIT Alumni Industry Interaction Center, IIT Madras Research Park, Chennai",
      year: "2024",
      photoLinks: [
        "https://drive.google.com/drive/folders/1FB7rYkOvy1lzTHYnnLtwroSx0JdA4K9z?usp=drive_link"
      ],
      thumbnail: "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      id: 12,
      name: "INTERNATIONAL CONFERENCE ON INNOVATIVE RESEARCH AND DEVELOPMENT (ICIRD - 2024) & INDO – THAI INTERNATIONAL EXCELLENCE AWARD",
      date: "FEBRUARY 26th to 28th, 2024",
      venue: "METHARATH UNIVERSITY, THAILAND",
      year: "2024",
      photoLinks: [
        "https://drive.google.com/drive/folders/1q64Gjj2AqsspcordJvgCtQXGUlatfFfE?usp=share_link"
      ],
      thumbnail: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      id: 13,
      name: "THE THICKEST BOOK IN THE WORLD & GUINNESS RECORD",
      date: "27th AUGUST 2023",
      venue: "HOTEL TURYAA, CHENNAI",
      year: "2023",
      photoLinks: [
        "https://drive.google.com/drive/u/5/folders/1Eds2hZIf7P5IxfCTtZ2cOwIV0JF_5z3q"
      ],
      thumbnail: "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      id: 14,
      name: "INTERNATIONAL CONFERENCE ON MULTIDISCIPLINARY RESEARCH AND DEVELOPMENT (ICMRD - 2023)",
      date: "SEPTEMBER 13th - 15th, 2023",
      venue: "Universiti Teknologi MARA, Puncak Alam Campus, Selangor",
      year: "2023",
      photoLinks: [
        "https://drive.google.com/drive/u/4/folders/1jVbA--52CcMW7eGdiErf3IC55Yh8Nc2S"
      ],
      thumbnail: "https://images.unsplash.com/photo-1523580494863-6f3031224c94?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      id: 15,
      name: "UAE INTERNATIONAL CONFERENCE ON MULTI DISCIPLINARY RESEARCH AND INNOVATION ICMRI-2023 & Multiple Awards",
      date: "23rd TO 25th JANUARY 2023",
      venue: "DUBAI, UAE",
      year: "2023",
      photoLinks: [
        "https://drive.google.com/drive/folders/12Zy_mFt1m2_6_-tBpmuPgmQAzUXY_H-b?usp=share_link"
      ],
      thumbnail: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      id: 16,
      name: "INTERNATIONAL CONFERENCE ON ROLE OF TECHNOLOGY & Multiple Awards",
      date: "JULY 29th – 30th, 2022",
      venue: "DECCENNIAL HALL, SAVEETHA SCHOOL OF MANAGEMENT, SIMATS, CHENNAI",
      year: "2022",
      photoLinks: [
        "https://drive.google.com/drive/u/0/folders/1yy3G8obFCcYv70oD5AjSFLu0bGptha1w"
      ],
      thumbnail: "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      id: 17,
      name: "INTERNATIONAL CONFERENCE ON LATEST TRENDS IN INNOVATION & INTERNATIONAL EDUCATION AWARD – 2022",
      date: "MAY 15TH, 2022",
      venue: "ALAPPUZHA, KERALA, INDIA",
      year: "2022",
      photoLinks: [
        "https://drive.google.com/drive/folders/1zqVrZKpCg8EvBHSrLZdh5CqoBEuxLK3H?usp=sharing"
      ],
      thumbnail: "https://images.unsplash.com/photo-1591115765373-5207764f72e7?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      id: 18,
      name: "INTERNATIONAL CONFERENCE ON MULTIDISCIPLINARY RESEARCH AND INNOVATION (ICMRI- 2022) & Multiple Awards",
      date: "MARCH 03rd to 05th, 2022",
      venue: "TAJ VIVANTA, GOA, INDIA",
      year: "2022",
      photoLinks: [
        "https://drive.google.com/drive/folders/1kkzdgUqZtX8dVnkG9QQAxPpDPsgbbpaG?usp=sharing"
      ],
      thumbnail: "https://images.unsplash.com/photo-1523580494863-6f3031224c94?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      id: 19,
      name: "PRIDE OF EDUCATION & PILLARS OF PUDUCHERRY & PILLARS OF INDIA",
      date: "SEPTEMBER 05th 2021",
      venue: "PUDUCHERRY",
      year: "2021",
      photoLinks: [
        "https://drive.google.com/drive/folders/14jrIRO55-5XxVzmrvEeC0Qo1cGzLIZ5O?usp=sharing"
      ],
      thumbnail: "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      id: 20,
      name: "INTERNATIONAL CONFERENCE ON MULTIDISCIPLINARY RESEARCH – 2021 & Multiple Awards",
      date: "NOVEMBER 26th & 27th 2021",
      venue: "HOTEL TURYAA, CHENNAI",
      year: "2021",
      photoLinks: [
        "https://drive.google.com/drive/folders/1CcWHaSflDGZ0w4q7Ku0_wdcAB_rVD5TL?usp=sharing"
      ],
      thumbnail: "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    }
  ];

  const filteredEvents = selectedCategory === 'All' 
    ? events 
    : events.filter(event => event.year === selectedCategory);

  const openEventGallery = (event) => {
    setSelectedEvent(event);
  };

  const closeEventGallery = () => {
    setSelectedEvent(null);
  };

  const downloadAllPhotos = (photoLinks) => {
    photoLinks.forEach((link, index) => {
      setTimeout(() => {
        window.open(link, '_blank');
      }, index * 500);
    });
  };

  if (selectedEvent) {
    return (
      <div style={{ backgroundColor: '#f8fafc', minHeight: '100vh', paddingTop: '80px' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '40px 20px' }}>
          <button
            onClick={closeEventGallery}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              backgroundColor: 'transparent',
              border: 'none',
              color: '#667eea',
              fontSize: '1rem',
              fontWeight: 600,
              cursor: 'pointer',
              marginBottom: '30px'
            }}
          >
            <ChevronLeft size={20} />
            Back to Gallery
          </button>

          <div style={{
            backgroundColor: 'white',
            borderRadius: '20px',
            padding: '40px',
            boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
            marginBottom: '40px'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: '30px', flexWrap: 'wrap', gap: '20px' }}>
              <div style={{ flex: 1 }}>
                <h1 style={{ 
                  color: '#2d3748', 
                  fontSize: '2rem', 
                  fontWeight: 700, 
                  marginBottom: '15px',
                  lineHeight: '1.3'
                }}>
                  {selectedEvent.name}
                </h1>
                
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '20px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <Calendar size={18} color="#667eea" />
                    <span style={{ color: '#4a5568', fontWeight: 600 }}>{selectedEvent.date}</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <MapPin size={18} color="#667eea" />
                    <span style={{ color: '#4a5568', fontWeight: 600 }}>{selectedEvent.venue}</span>
                  </div>
                </div>
              </div>
              
              <button
                onClick={() => downloadAllPhotos(selectedEvent.photoLinks)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  padding: '15px 30px',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '25px',
                  fontSize: '1rem',
                  fontWeight: 600,
                  cursor: 'pointer',
                  transition: 'transform 0.2s ease',
                  boxShadow: '0 5px 15px rgba(102, 126, 234, 0.3)'
                }}
                onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
                onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
              >
                <Download size={20} />
                Download All Photos
              </button>
            </div>

            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
              gap: '20px' 
            }}>
              {selectedEvent.photoLinks.map((link, index) => (
                <div key={index} style={{
                  background: 'linear-gradient(135deg, #667eea20 0%, #764ba210 100%)',
                  padding: '3px',
                  borderRadius: '15px',
                  boxShadow: '0 5px 20px rgba(0,0,0,0.1)'
                }}>
                  <div style={{
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    padding: '20px',
                    textAlign: 'center'
                  }}>
                    <div style={{
                      width: '100%',
                      height: '200px',
                      backgroundColor: '#f7fafc',
                      borderRadius: '10px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '15px',
                      border: '2px dashed #e2e8f0'
                    }}>
                      <span style={{ color: '#718096', fontSize: '0.9rem' }}>Photo Collection {index + 1}</span>
                    </div>
                    <button
                      onClick={() => window.open(link, '_blank')}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px',
                        width: '100%',
                        padding: '12px 20px',
                        backgroundColor: '#667eea',
                        color: 'white',
                        border: 'none',
                        borderRadius: '20px',
                        fontSize: '0.9rem',
                        fontWeight: 600,
                        cursor: 'pointer',
                        transition: 'all 0.2s ease'
                      }}
                      onMouseEnter={(e) => e.target.style.backgroundColor = '#5a67d8'}
                      onMouseLeave={(e) => e.target.style.backgroundColor = '#667eea'}
                    >
                      <ExternalLink size={16} />
                      View Photos
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ backgroundColor: '#f8fafc', minHeight: '100vh' }}>
      {/* Hero Section */}
      <section className="hero-section text-center" style={{ 
        background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.9), rgba(118, 75, 162, 0.9)), url("https://images.unsplash.com/photo-1540575467063-178a50c2df87?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80")',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}>
        <div className="container-custom">
          <h1 className="heading-1 text-white mb-6">Event Gallery</h1>
          <p className="body-large text-white mb-8" style={{ maxWidth: '700px', margin: '0 auto 2rem', opacity: 0.95 }}>
            Capturing memorable moments from our conferences, workshops, awards ceremonies, and networking events
          </p>
        </div>
      </section>

      <div className="container-custom" style={{ padding: '80px 24px' }}>
        {/* Category Filter */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          gap: '16px', 
          marginBottom: '60px',
          flexWrap: 'wrap'
        }}>
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              style={{
                padding: '12px 24px',
                borderRadius: '25px',
                border: 'none',
                backgroundColor: selectedCategory === category ? '#667eea' : 'white',
                color: selectedCategory === category ? 'white' : '#667eea',
                cursor: 'pointer',
                fontSize: '0.95rem',
                fontWeight: 600,
                transition: 'all 0.2s',
                boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
              }}
              onMouseEnter={(e) => {
                if (selectedCategory !== category) {
                  e.target.style.backgroundColor = '#667eea';
                  e.target.style.color = 'white';
                }
              }}
              onMouseLeave={(e) => {
                if (selectedCategory !== category) {
                  e.target.style.backgroundColor = 'white';
                  e.target.style.color = '#667eea';
                }
              }}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Events Grid */}
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', 
          gap: '30px',
          marginBottom: '60px'
        }}>
          {filteredEvents.map((event) => (
            <div 
              key={event.id} 
              style={{ 
                background: 'linear-gradient(135deg, #667eea20 0%, #764ba210 100%)',
                padding: '3px',
                borderRadius: '20px',
                boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
                cursor: 'pointer',
                transition: 'transform 0.3s ease'
              }}
              onClick={() => openEventGallery(event)}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-8px)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            >
              <div style={{
                backgroundColor: 'white',
                borderRadius: '17px',
                overflow: 'hidden'
              }}>
                <img 
                  src={event.thumbnail} 
                  alt={event.name}
                  style={{ 
                    width: '100%', 
                    height: '250px', 
                    objectFit: 'cover'
                  }}
                />
                <div style={{ padding: '30px' }}>
                  <div style={{
                    backgroundColor: '#667eea',
                    color: 'white',
                    padding: '6px 15px',
                    borderRadius: '15px',
                    fontSize: '0.8rem',
                    fontWeight: 600,
                    display: 'inline-block',
                    marginBottom: '15px'
                  }}>
                    {event.year}
                  </div>
                  
                  <h3 style={{ 
                    color: '#2d3748', 
                    fontSize: '1.2rem', 
                    fontWeight: 700, 
                    marginBottom: '15px',
                    lineHeight: '1.4',
                    display: '-webkit-box',
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden'
                  }}>
                    {event.name}
                  </h3>
                  
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '20px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <Calendar size={16} color="#667eea" />
                      <span style={{ color: '#4a5568', fontSize: '0.9rem', fontWeight: 500 }}>{event.date}</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <MapPin size={16} color="#667eea" />
                      <span style={{ 
                        color: '#4a5568', 
                        fontSize: '0.9rem', 
                        fontWeight: 500,
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden'
                      }}>
                        {event.venue}
                      </span>
                    </div>
                  </div>
                  
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ 
                      color: '#718096', 
                      fontSize: '0.9rem', 
                      fontWeight: 500 
                    }}>
                      {event.photoLinks.length} Photo Collection{event.photoLinks.length > 1 ? 's' : ''}
                    </span>
                    <button style={{
                      padding: '8px 16px',
                      backgroundColor: '#667eea',
                      color: 'white',
                      border: 'none',
                      borderRadius: '15px',
                      fontSize: '0.85rem',
                      fontWeight: 600,
                      cursor: 'pointer'
                    }}>
                      View Gallery
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Gallery;